import { RevealBox, SectionLabel, SectionTitle, SectionSub } from './UI';

const testimonials = [
  { init:'PS', name:'Poonam Shinde', loc:'Mumbai, Maharashtra', prog:'MBA – Amity University', quote:'iGrade made my admission process seamlessly stress-free. I went from total confusion to officially enrolled in Amity\'s MBA within a week. The counsellor was knowledgeable, patient, and genuinely invested in my success.' },
  { init:'RS', name:'Rahul Singh', loc:'Noida, Uttar Pradesh', prog:'MCA – DY Patil University', quote:'As a working professional with zero time, iGrade handled everything — documentation, counselling, university liaison. I literally just showed up to start learning. Absolutely brilliant service.' },
  { init:'AK', name:'Ananya Krishnan', loc:'Bengaluru, Karnataka', prog:'MCom – NMIMS', quote:'The personalised support was exceptional. My counsellor matched me to exactly the right program for my background and career goals. 6 months in and I couldn\'t be happier with this decision.' },
  { init:'MK', name:'Mohammed Khan', loc:'Hyderabad, Telangana', prog:'BBA – Chandigarh University', quote:'I was skeptical about online education but iGrade completely changed my perception. The university they recommended has given me incredible opportunities I never imagined possible.' },
  { init:'SV', name:'Sunita Verma', loc:'Jaipur, Rajasthan', prog:'MA – Manipal University', quote:'As a homemaker returning to education after 8 years, I was nervous. The iGrade team held my hand through every step. Now I\'m thriving in my online MA program from the comfort of home.' },
  { init:'DM', name:'Deepak Mehta', loc:'Ahmedabad, Gujarat', prog:'MBA – Amity University', quote:'Got promoted within 6 months of starting my online MBA through iGrade. My manager was impressed by the Amity brand name. The ROI on this degree has been phenomenal already.' },
];

const awards = [
  '🏆 Best EdTech Platform 2025-26', '🏅 UGC-DEB Compliant Partner',
  '⭐ Google 4.9★ Rated', '🌐 WES-Approved Programs',
  '🎖️ AIU Recognised Institution', '🏛️ PAN-India Excellence Award',
];

export default function Trust() {
  return (
    <section id="trust" style={{ padding: '100px 6%', background: 'var(--navy)' }}>
      <RevealBox>
        <SectionLabel dark>Student Stories</SectionLabel>
        <SectionTitle style={{ color:'#fff', maxWidth:'100%' }}>
          400+ Lives <em style={{ fontStyle:'italic', color:'var(--yellow)' }}>Transformed</em>
        </SectionTitle>
        <SectionSub style={{ color:'rgba(255,255,255,0.58)' }}>
          Don't take our word for it — hear from the students and professionals who chose iGrade.
        </SectionSub>
      </RevealBox>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: 20, marginTop: 56,
      }}>
        {testimonials.map((t, i) => (
          <RevealBox key={t.name} delay={i * 0.07}>
            <div style={{
              background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)',
              borderRadius: 'var(--radius)', padding: '30px 28px',
              transition: 'all 0.3s', cursor: 'default',
            }}
            onMouseEnter={e => { e.currentTarget.style.background='rgba(255,255,255,0.09)'; e.currentTarget.style.transform='translateY(-4px)'; }}
            onMouseLeave={e => { e.currentTarget.style.background='rgba(255,255,255,0.05)'; e.currentTarget.style.transform='translateY(0)'; }}
            >
              <div style={{ color:'var(--yellow)', fontSize:14, letterSpacing:2, marginBottom:14 }}>★★★★★</div>
              <p style={{ fontSize:14.5, color:'rgba(255,255,255,0.75)', lineHeight:1.72, marginBottom:24, fontStyle:'italic' }}>
                "{t.quote}"
              </p>
              <div style={{ borderTop:'1px solid rgba(255,255,255,0.1)', paddingTop:18, display:'flex', alignItems:'center', gap:12 }}>
                <div style={{
                  width:44, height:44, borderRadius:'50%',
                  background:'var(--yellow)', display:'grid', placeItems:'center',
                  fontFamily:'Playfair Display,serif', fontWeight:700, fontSize:16, color:'var(--navy)',
                  flexShrink:0,
                }}>{t.init}</div>
                <div>
                  <div style={{ fontWeight:700, fontSize:15, color:'#fff' }}>{t.name}</div>
                  <div style={{ fontSize:12, color:'rgba(255,255,255,0.45)', marginTop:2 }}>{t.loc} · {t.prog}</div>
                </div>
              </div>
            </div>
          </RevealBox>
        ))}
      </div>

      {/* Awards */}
      <RevealBox style={{ marginTop:80, borderTop:'1px solid rgba(255,255,255,0.1)', paddingTop:60 }}>
        <p style={{ textAlign:'center', fontSize:12, fontWeight:700, letterSpacing:'2.5px', textTransform:'uppercase', color:'rgba(255,255,255,0.35)', marginBottom:32 }}>
          RECOGNITIONS & INSTITUTIONAL AFFILIATIONS
        </p>
        <div style={{ display:'flex', flexWrap:'wrap', gap:12, justifyContent:'center' }}>
          {awards.map(a => (
            <span key={a} style={{
              background:'rgba(245,197,24,0.1)', border:'1px solid rgba(245,197,24,0.25)',
              padding:'10px 22px', borderRadius:999,
              fontSize:13, fontWeight:600, color:'rgba(255,255,255,0.82)',
            }}>{a}</span>
          ))}
        </div>
      </RevealBox>
    </section>
  );
}
